<template>
  <div>
    <!--Banner 区域 -->
    <img src="../../assets/img/learning_5.webp" alt="product-bg" class="w-full h-auto md:h-full object-cover" />
    <div class="w-full h-auto md:h-[333px] -mt-8 sm:-mt-12 md:-mt-[60px] gradient-black-bg pb-8 sm:pb-12 md:pb-0">
      <div class="grid grid-cols-1 md:grid-cols-3 gap-3 sm:gap-6 md:gap-8 mx-auto container px-4 sm:px-6 md:px-8">
        <div
          class="relative rounded-[2rem] sm:rounded-[3rem] md:rounded-[4rem] scroll-fade-in gradient-border-card overflow-hidden"
          style="background: linear-gradient(135deg, rgba(59, 130, 246, 0.1), rgba(168, 85, 247, 0.3), rgba(236, 72, 153, 0.5));">
          <div
            class="relative rounded-xl sm:rounded-[2rem] md:rounded-[4rem] bg-black/20 backdrop-blur-md p-4 sm:p-6 md:p-8 h-auto md:h-full min-h-[120px] sm:min-h-[150px] md:min-h-0 flex flex-col items-center justify-center text-center">
            <div class="text-white text-3xl sm:text-5xl md:text-6xl mb-1 sm:mb-2 md:mb-4">10+</div>
            <div class="text-white text-xs sm:text-base md:text-[16px]">项核心知识产权</div>
            <div class="text-white text-xs sm:text-base md:text-[16px] opacity-90">自主研发多套核心系统</div>
          </div>
        </div>
        <div
          class="relative rounded-[2rem] sm:rounded-[3rem] md:rounded-[4rem] scroll-fade-in gradient-border-card overflow-hidden"
          style="background: linear-gradient(135deg, rgba(59, 130, 246, 0.1), rgba(168, 85, 247, 0.3), rgba(236, 72, 153, 0.5));">
          <div
            class="relative rounded-xl sm:rounded-[2rem] md:rounded-[4rem] bg-black/20 backdrop-blur-md p-4 sm:p-6 md:p-8 h-auto md:h-full min-h-[120px] sm:min-h-[150px] md:min-h-0 flex flex-col items-center justify-center text-center">
            <div class="text-white text-3xl sm:text-5xl md:text-6xl mb-1 sm:mb-2 md:mb-4">15+</div>
            <div class="text-white text-xs sm:text-base md:text-[16px]">LBE-VR大空间业态</div>
            <div class="text-white text-xs sm:text-base md:text-[16px] opacity-90">落地城市门店超15家</div>
          </div>
        </div>
        <div
          class="relative rounded-[2rem] sm:rounded-[3rem] md:rounded-[4rem] scroll-fade-in gradient-border-card overflow-hidden"
          style="background: linear-gradient(135deg, rgba(59, 130, 246, 0.1), rgba(168, 85, 247, 0.3), rgba(236, 72, 153, 0.5));">
          <div
            class="relative rounded-xl sm:rounded-[2rem] md:rounded-[4rem] bg-black/20 backdrop-blur-md p-4 sm:p-6 md:p-8 h-auto md:h-full min-h-[120px] sm:min-h-[150px] md:min-h-0 flex flex-col items-center justify-center text-center">
            <div class="text-white text-3xl sm:text-5xl md:text-6xl mb-1 sm:mb-2 md:mb-4">10<span
                class="text-lg sm:text-2xl">年</span></div>
            <div class="text-white text-xs sm:text-base md:text-[16px]">核心团队技术骨干</div>
            <div class="text-white text-xs sm:text-base md:text-[16px] opacity-90">深耕空间文娱领域超10年</div>
          </div>
        </div>
      </div>
      <div
        class="text-white text-lg sm:text-xl md:text-2xl lg:text-[36px] font-bold text-center mb-8 sm:mb-12 md:mb-16 lg:mb-[125px] scroll-fade-in mt-6 sm:mt-8 md:mt-12 lg:mt-[60px] px-4">
        科技感强、互动性高、知识传递高效、安全可控、适配多场景
      </div>
    </div>
    <!-- 「全场景覆盖·多元载体轻松落地」 -->
    <div class="w-full h-auto bg-[#0C3D8E] flex flex-col items-center justify-center relative ">

      <img src="../../assets/img/learning_cj_bg.png" alt="全场景覆盖·多元载体轻松落地-背景图"
        class="w-full h-auto md:h-full object-cover scroll-fade-in  sm:px-0 md:px-0 lg:px-0" />
      <div class="w-full h-full flex flex-col items-center justify-center absolute top-[28px] sm:top-[18px] left-0 right-0 bottom-6">
        <img src="../../assets/img/learning_qsld.webp" alt="全场景覆盖·多元载体轻松落地"
          class="scroll-fade-in object-contain h-[60px] sm:h-[60px] md:h-[117px] lg:h-[117px] mb-[26px]" />
        <div
          class="text-white text-sm sm:text-base md:text-[24px] text-center md:text-left sm:mb-6 md:mb-8 lg:mb-12 container mx-auto fade-in-visible">
          项目适配全类型合作载体，无论你是现有场馆升级，还是从零创业，均可快速落地：中小学科创教室、青少年活动中心、科技馆/博物馆、文旅景区/研学基地、商业综合体教培区、社区科普站、创业体验店，一店多能，兼顾研学授课、团体体验、散客消费，盈利渠道多元化。
        </div>

        <img src="../../assets/img/learning_cj_img.webp" alt="全场景覆盖·多元载体轻松落地-背景图"
          class="object-contain scroll-fade-in container md:px-[121px] lg:px-[361px] px-[60px]" />
      </div>
    </div>

    <!-- 「核心赋能 · 省心运营不费力」 -->
    <div class="w-full h-auto bg-[#15184F] flex flex-col items-center justify-center sm:pb-4">
      <img src="../../assets/img/learning_hxfn.webp" alt="核心赋能 · 省心运营不费力"
        class="scroll-fade-in object-contain h-[60px] sm:h-[60px] md:h-[117px] mt-[28px] sm:mt-[18px] md:mt-[68px] mb-[97px]" />
      <div
        class="flex flex-col sm:flex-col md:flex-row md:items-start lg:items-start items-center justify-around container sm:gap-0 gap-[124px] w-full">
        <div
          class="flex flex-col items-start max-w-[336px] mt-[12px] sm:mb-4 sm:w-full sm:items-center lg:items-start sm:mt-[18px] md:mt-[121px] lg:mt-[121px]">
          <div class="text-white text-xl sm:text-xl md:text-2xl lg:text-2xl font-bold text-start scroll-fade-in-left">
            内容实时迭代，避免内容同质化</div>
          <div
            class="w-[100px] sm:w-[120px] lg:w-[200px] h-1 bg-[#0BE0BB] rounded-[2px] mt-[14px] sm:mt-[10px] scroll-fade-in-left">
          </div>
          <div
            class="text-white text-xs sm:text-sm md:text-base lg:text-[16px] font-normal text-start scroll-fade-in-left mt-6">
            每月更新沉浸式内容，无需额外投入，保持内容新鲜感。</div>
          <div
            class="text-white text-xs sm:text-sm md:text-base lg:text-[16px] font-normal text-start scroll-fade-in-left mt-5">
            聚合三大系列、11 部 +精品产品，一站式满足各类内容诉求</div>
        </div>
        <img src="../../assets/img/learning_10.webp" alt="核心赋能 · 省心运营不费力-背景图"
          class="object-contain scroll-fade-in mb-[100px] md:max-w-[782px] lg:max-w-[782px] max-w-[300px] sm:px-4" />
      </div>
    </div>

    <!-- 智能播控管理·一人轻松运维 -->
    <div class="w-full h-auto bg-[#15184F] flex flex-col items-center justify-center sm:pb-4"
      :style="{ backgroundImage: `url(${znbkglBg})`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' }">
      <img src="../../assets/img/learning_znbkgl.webp" alt="核心赋能 · 省心运营不费力"
        class="scroll-fade-in object-contain h-[60px] sm:h-[60px] md:h-[117px] mt-[28px] sm:mt-[68px] md:mt-[68px] mb-[97px]" />

      <div class="flex flex-col items-center justify-center container">
        <div class="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-3 gap-4 sm:gap-4 md:gap-[200px]">
          <img src="../../assets/img/bokong_2.png" alt="learning_8"
            class="object-contain max-w-[200px] sm:max-w-[200px] md:max-w-[250px] lg:max-w-[367px] fade-in-visible scroll-fade-in-left" />
          <img src="../../assets/img/bokong_4.png" alt="learning_8"
            class="object-contain max-w-[200px] sm:max-w-[200px] md:max-w-[250px] lg:max-w-[367px] fade-in-visible " />
          <img src="../../assets/img/bokong_1.png" alt="learning_8"
            class="object-contain max-w-[200px] sm:max-w-[200px] md:max-w-[250px] lg:max-w-[367px] fade-in-visible scroll-fade-in-right" />
        </div>

        <div
          class="text-white text-xs sm:text-sm md:text-base lg:text-[20px] font-bold text-start scroll-fade-in-left mt-4 sm:mt-4 md:-mt-9 lg:-mt-9">
          自研智能播控系统，无需专业技术人员，降低运维成本，小白也能轻松上手。</div>

        <img src="../../assets/img/bokong_3.png" alt="learning_8"
          class="object-contain max-w-[200px] sm:max-w-[200px] md:max-w-[250px] lg:max-w-[367px] mt-5 fade-in-visible scroll-fade-in-right" />
      </div>
    </div>
    <img src="../../assets/img/learning_8.webp" alt="learning_8"
      class="w-full h-auto md:h-full object-cover scroll-fade-in" />
    <!-- 合作模式 -->
    <div
      class="w-full min-h-screen bg-cover bg-center scroll-fade-in relative pt-8 sm:pt-12 md:pt-16 lg:pt-[68px] pb-8 sm:pb-12 md:pb-16 lg:pb-[105px]"
      :style="{ backgroundImage: `url(${cooperationbg})` }">
      <div class="max-w-[1400px] mx-auto px-4 sm:px-6 md:px-8">
        <div class="flex flex-col items-center justify-center ">
          <!-- 合作意向 -->
          <div class="w-full mx-auto flex flex-col items-center justify-center">
            <img src="../../assets/img/learing_hzyx.webp" alt="scene"
              class="mb-4 sm:mb-6 md:mb-8 lg:mb-12 w-full max-w-[100px] sm:max-w-[122px] md:max-w-[144px] lg:max-w-none scroll-fade-in fade-in-visible object-contain h-[117px]" />
            <div
              class="text-white text-sm sm:text-base md:text-[20px] text-center md:text-left ml-[24px] mb-4 sm:mb-6 md:mb-8 lg:mb-12">
              不做同质化内卷，只做科技化创新！XR智慧研学项目，以硬核技术+优质内容+全链路扶持，打造研学市场新标杆。
            </div>
          </div>
          <CooperationForm />
        </div>
      </div>
    </div>
    <div class="w-full relative min-h-[600px] md:h-[482px]"
      style="background: linear-gradient(to bottom, #6267F4 0%, #4247E6 33%, black 100%);">
      <img src="../../assets/img/squarebg.webp" alt="Digital Handshake"
        class="object-cover w-full h-full min-h-[600px] md:h-full scroll-fade-in-left">
      <div class="absolute top-0 left-0 w-full h-full min-h-[600px] md:h-full bg-black/50 scroll-fade-in">
        <div
          class="container mx-auto flex flex-col md:flex-row items-center md:items-end justify-center gap-4 sm:gap-6 md:gap-12 lg:gap-[100px] h-full min-h-[600px] md:h-full py-6 sm:py-8 md:py-0 px-4 sm:px-6 md:px-8">
          <img src="../../assets/img/square.webp" alt="Digital Handshake" class="object-contain h-auto w-full 
            lg:mr-[140px]
            max-w-[150px] sm:max-w-[200px] md:max-w-[300px] md:h-full order-1 md:order-none" />
          <div
            class="h-auto md:h-full flex flex-col items-center md:items-start justify-center w-full max-w-full md:w-[600px] md:my-[20px] order-2 md:order-none">
            <div class="items-start w-full flex flex-col justify-center">
              <div class="flex flex-col justify-center items-center md:items-start w-full ml-[11px]">
                <div class="text-white text-lg sm:text-xl md:text-[24px] font-bold text-center md:text-left ml-[24px]">
                  快速联系</div>
                <div class="text-white text-sm sm:text-base md:text-[16px] font-bold mt-1 text-center md:text-left">
                  立即加入，抢占先机</div>
              </div>
            </div>
            <div class="flex flex-col gap-2 sm:gap-3 md:gap-5 w-full mt-3 sm:mt-4 md:mt-[10%]">
              <div class="text-white text-xs sm:text-sm md:text-[20px] font-bold text-center md:text-left break-all
              lg:pb-[71px] pb-2 px-2
               md:px-0">
                邮箱：<span class="break-all">newmail110@163.com</span>
              </div>
              <div class="text-white text-xs 
              lg:pb-[69px] pb-2
              sm:text-sm md:text-[20px] font-bold text-center md:text-left break-words px-2 md:px-0">
                招商热线：130 5258 5965
              </div>
              <div
                class="text-white text-xs sm:text-sm md:text-[20px] font-bold text-center md:text-left break-words px-2 md:px-0">
                总部地址：上海市闵行区万芳路515号A座8层
              </div>
            </div>
          </div>
          <div
            class="flex flex-row gap-3 sm:gap-4 justify-center md:justify-start mb-4 md:mb-[5%] scroll-fade-in-right order-3 md:order-none">
            <div class="flex flex-col items-center">
              <div
                class="w-[80px] h-[80px] sm:w-[100px] sm:h-[100px] md:w-[110px] md:h-[110px] bg-white rounded-lg mb-2 flex items-center justify-center overflow-hidden">
                <img :src="productCodeImg" alt="产品支持二维码" class="w-full h-full object-contain" />
              </div>
              <div class="text-white text-[10px] sm:text-[12px] md:text-[14px]">产品支持</div>
            </div>
            <div class="flex flex-col items-center">
              <div
                class="w-[80px] h-[80px] sm:w-[100px] sm:h-[100px] md:w-[110px] md:h-[110px] bg-white rounded-lg mb-2 flex items-center justify-center overflow-hidden">
                <img :src="coopCodeImg" alt="合作咨询二维码" class="w-full h-full object-contain" />
              </div>
              <div class="text-white text-[10px] sm:text-[12px] md:text-[14px]">合作咨询</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { onMounted, onBeforeUnmount } from "vue";
import CooperationForm from "@/components/CooperationForm.vue";
import cooperationbg from "@/assets/img/learning_11.webp";
import productCodeImg from "@/assets/img/product-code.webp";
import coopCodeImg from "@/assets/img/coop-code.webp";
import znbkglBg from "@/assets/img/learning_9.webp";
// 存储已触发动画的元素
const animatedElements = new Set<HTMLElement>();

// Intersection Observer 配置
const observerOptions: IntersectionObserverInit = {
  root: null,
  rootMargin: "0px",
  threshold: 0.1, // 当元素10%可见时触发
};

// 创建 Intersection Observer
let observer: IntersectionObserver | null = null;

onMounted(() => {
  // 创建 observer
  observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (
        entry.isIntersecting &&
        !animatedElements.has(entry.target as HTMLElement)
      ) {
        // 元素进入视口且未触发过动画
        const element = entry.target as HTMLElement;
        element.classList.add("fade-in-visible");
        animatedElements.add(element);
      }
    });
  }, observerOptions);

  // 观察所有带有滚动动画类的元素（与产品页保持一致）
  const elements = document.querySelectorAll(
    ".scroll-fade-in, .scroll-fade-in-left, .scroll-fade-in-right"
  );
  elements.forEach((element) => {
    if (observer) {
      observer.observe(element);
    }
  });
});

onBeforeUnmount(() => {
  if (observer) {
    observer.disconnect();
  }
});
</script>

<style scoped>
/* 滚动动画效果 - 小元素从底部飞入 */
.scroll-fade-in {
  opacity: 0;
  transform: translateY(50px);
  transition: opacity 0.8s ease-out, transform 0.8s ease-out;
}

.scroll-fade-in.fade-in-visible {
  opacity: 1;
  transform: translateY(0);
}

/* 滚动动画效果 - 从左边飞入 */
.scroll-fade-in-left {
  opacity: 0;
  transform: translateX(-50px);
  transition: opacity 0.8s ease-out, transform 0.8s ease-out;
}

.scroll-fade-in-left.fade-in-visible {
  opacity: 1;
  transform: translateX(0);
}

/* 滚动动画效果 - 从右边飞入 */
.scroll-fade-in-right {
  opacity: 0;
  transform: translateX(50px);
  transition: opacity 0.8s ease-out, transform 0.8s ease-out;
}

.scroll-fade-in-right.fade-in-visible {
  opacity: 1;
  transform: translateX(0);
}

/* 百叶窗式大图动画容器（横向百叶窗：条纹水平、整体上下滑出） */
.blinds-reveal {
  position: relative;
  overflow: hidden;
}

.blinds-reveal img {
  display: block;
  width: 100%;
  height: auto;
  transform: scale(1.03);
  transition: transform 1.2s ease-out;
}

/* 叠加的“百叶窗”遮罩 */
.blinds-reveal::before {
  content: "";
  position: absolute;
  inset: 0;
  /* 横向百叶窗：竖向分层（条纹水平），整体从下往上滑出 */
  background-image: repeating-linear-gradient(to bottom,
      rgba(4, 16, 40, 0.95) 0px,
      rgba(4, 16, 40, 0.95) 24px,
      transparent 24px,
      transparent 40px);
  transform: translateY(0);
  transition: transform 1.2s ease-out;
  pointer-events: none;
}

/* 进入视口后，遮罩整体上移出画面，形成横向百叶窗打开效果 */
.blinds-reveal.fade-in-visible::before {
  transform: translateY(-100%);
}

.blinds-reveal.fade-in-visible img {
  transform: scale(1);
}

/* 第二张图稍微延迟一点打开 */
.blinds-reveal--delay::before {
  transition-delay: 0.15s;
}

.blinds-reveal--delay img {
  transition-delay: 0.15s;
}

/* 星星点点渐隐展示效果容器 */
.dots-reveal {
  position: relative;
  overflow: hidden;
}

.dots-reveal img {
  display: block;
  width: 100%;
  height: auto;
  transform: scale(1.03);
  transition: transform 1.4s ease-out;
}

.dots-reveal::before {
  content: "";
  position: absolute;
  inset: 0;
  /* 星星点点：用径向渐变 + 重复平铺制造随机感 */
  background-image: radial-gradient(circle at 10% 20%,
      rgba(4, 16, 40, 0.95) 0,
      rgba(4, 16, 40, 0.95) 3px,
      transparent 4px),
    radial-gradient(circle at 40% 80%,
      rgba(4, 16, 40, 0.9) 0,
      rgba(4, 16, 40, 0.9) 4px,
      transparent 5px),
    radial-gradient(circle at 80% 30%,
      rgba(4, 16, 40, 0.9) 0,
      rgba(4, 16, 40, 0.9) 2px,
      transparent 3px),
    radial-gradient(circle at 60% 60%,
      rgba(4, 16, 40, 0.95) 0,
      rgba(4, 16, 40, 0.95) 3px,
      transparent 4px),
    radial-gradient(circle at 20% 70%,
      rgba(4, 16, 40, 0.9) 0,
      rgba(4, 16, 40, 0.9) 2px,
      transparent 3px);
  background-color: rgba(4, 16, 40, 0.92);
  opacity: 1;
  transition: opacity 1.4s ease-out;
  pointer-events: none;
}

/* 进入视口后，遮罩整体淡出，图片略微缩放回正，形成星点散开的感觉 */
.dots-reveal.fade-in-visible::before {
  opacity: 0;
}

.dots-reveal.fade-in-visible img {
  transform: scale(1);
}

.gradient-black-bg {
  position: relative;
  background: transparent;
}

.gradient-black-bg::before {
  content: "";
  position: absolute;
  inset: 0;
  background: #151827;
  mask-image: linear-gradient(to bottom,
      transparent 0%,
      #151827 18%,
      #151827 100%);
  -webkit-mask-image: linear-gradient(to bottom,
      transparent 0%,
      #151827 18%,
      #151827 100%);
  pointer-events: none;
}

.gradient-border-card {
  position: relative;
}

.gradient-border-card::before {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: inherit;
  padding: 2px;
  background: linear-gradient(135deg, #40fff9, #e068ff);
  -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  -webkit-mask-composite: xor;
  mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  mask-composite: exclude;
  pointer-events: none;
  z-index: 1;
}
</style>
